<template>
  <div class="bg-[#F9F9F9] py-10 text-center">
    <div class="container mx-auto px-5">
      <h1
        class="flex items-center justify-center text-[#645C8C] w-full font-extrabold text-3xl lg:text-4xl leading-9"
      >
        {{ t("home.getCardSection.title") }}
      </h1>

      <p class="mt-6 text-sm text-brand-gray max-w-sm mx-auto">
        {{ t("home.getCardSection.description") }}
      </p>

      <div
        class="hidden lg:flex items-center w-full my-6 px-4 max-w-3xl mx-auto"
      >
        <div class="flex items-center justify-center w-full">
          <template v-for="(step, index) in steps" :key="step">
            <div
              class="flex justify-center items-center size-16 bg-gradient-to-l to-[#E72B6F] from-[#1450A0] rounded-full text-white text-3xl font-bold"
            >
              {{ step }}
            </div>

            <div
              v-if="index < steps.length - 1"
              class="flex-1 border-t-2 border-[#D7D7D7] border-dotted mx-2"
            ></div>
          </template>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 my-10">
        <template v-for="(key, i) in reasonsKeys" :key="key">
          <div
            class="flex flex-col"
            :class="{
              'md:col-span-1 lg:col-span-1': key === 'first',
              'md:col-span-1 lg:col-span-1': key === 'second',
              'md:col-span-2 lg:col-span-1': key === 'third',
            }"
          >
            <div
              class="flex mx-auto mb-5 lg:hidden justify-center items-center size-16 bg-gradient-to-l to-[#E72B6F] from-[#1450A0] rounded-full text-white text-3xl font-bold"
            >
              0{{ i + 1 }}
            </div>

            <div
              class="flex-1 rounded-sm max-w-sm mx-auto md:max-w-full shadow-lg bg-white py-10 px-12"
            >
              <div class="lg:h-10 text-lg font-bold">
                {{ t(`home.getCardSection.reasons.${key}.title`) }}
              </div>
              <div class="md:h-auto lg:h-24 text-sm text-[#7A7A7A]">
                {{ t(`home.getCardSection.reasons.${key}.subtitle`) }}
              </div>
            </div>
          </div>
        </template>
      </div>

      <div v-if="!isLoggedIn">
        <button
          class="bg-cerise-red-600 text-white px-8 py-3 rounded-full text-lg"
        >
          <nuxt-link :to="localePath('register')">
            {{ t("labels.join") }}
          </nuxt-link>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const localePath = useLocalePath();
const cookie = useCookie("authenticated")
const isLoggedIn = ref(computed(() => (cookie.value ? true : false)));

const steps = ["01", "02", "03"];
const reasonsKeys = ["first", "second", "third"];
</script>
